interface BraindayWordmarkProps {
  width?: number;
  className?: string;
}

export function BraindayWordmark({ width = 220, className }: BraindayWordmarkProps) {
  const height = Math.round((width / 220) * 48);
  return (
    <svg
      viewBox="0 0 220 48"
      width={width}
      height={height}
      role="img"
      aria-label="Brainday"
      className={className}
    >
      {/* Theme-adaptive mark — see BraindayMark. Tile = currentColor (the SVG is
          given text-t1 by callers), muted bars = canvas, accent = brand. */}
      <rect x="0" y="8" width="32" height="32" rx="7" fill="currentColor" />
      <rect x="7" y="17" width="18" height="3.5" rx="1.75" fill="var(--canvas)" opacity="0.32" />
      <rect x="7" y="22.5" width="14" height="3.5" rx="1.75" fill="var(--brand)" />
      <rect x="7" y="28" width="11" height="3.5" rx="1.75" fill="var(--canvas)" opacity="0.32" />
      <text
        x="42"
        y="31"
        fontFamily="Geist, system-ui, sans-serif"
        fontWeight="500"
        fontSize="20"
        fill="currentColor"
        letterSpacing="-0.02em"
      >
        Brainday
      </text>
    </svg>
  );
}
